export const DashboardDelivery = {
  title: 'Pedidos Entregues'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardDelivery.js